import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { useClientId } from '../../../_hooks/useClientId';
import { AssetsDTO } from '../../../CommonTypes/AssetsDTO';
import { AllocationTaxStatusDTO } from './useAccountsQuery';

export interface AccountPortfolioBody {
  AccountId: string;
  AccountPortfolioByTaxStatuses: AccountPortfolioByTaxStatuses[];
  clientId: number;
}

export interface AccountPortfolioByTaxStatuses {
  TaxStatus: AllocationTaxStatusDTO | null;
  AssetAllocation: AssetsDTO[];
  HypotheticalReturn?: string | number | null;
}

interface Params extends Omit<AccountPortfolioBody, 'clientId'> {}

const accountPortfolioSave = (clientId: number) => (params: Params) =>
  authFetch('/Consumer/AccountPortfolioUpdate/Save', {
    method: 'POST',
    ...httpBodyOptions(
      {
        ...params,
        clientId,
      },
      true,
    ),
  });

export const useAccountPortfolioMutation = () => {
  const clientId = useClientId();

  return useMutation(accountPortfolioSave(clientId));
};
